import styled from 'styled-components'
import { hFlex } from '../../../../../../../../../../Styles/style-helpers'
import { Link } from 'react-router-dom'
import { accent } from '../../../../../../../../../../Styles/colors'

export const LessonEl = styled(Link)`
  ${hFlex};
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 0.5em;
  opacity: ${({ active }) => (active ? 1 : 0.7)};
  color: ${({ active }) => (active ? accent : 'white')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  & > svg {
    font-size: 1.5em;
    margin-right: 0.5em;
  }
`
